export default "__VITE_ASSET__3e3fe5bb__"